'use strict';

import angular from 'angular';

import bookingDate from './booking_date';
import cityPhoto from './city_photo';
import duration from './duration';
import language from './language';
import location from './location';
import meetingTime from './meeting_time';
import nl2br from './nl2br';
import numberOfPeople from './number_of_people';
import phone from './phone';
import possessive from './possessive.filter';
import responseTime from './response_time';
import toDate from './to_date';
import firstName from './first_name';
import booking from './booking.filter';
import longShortDate from './long_short_date.filter';
import priceFilter from './guide_price.filter';
import limitWords from './limit_words.filter';
import country from './country_filter';
import guideSlug from './guide_slug.filter';
import roundFilter from './round.filter';
import spacesWithDashes from './spaces_with_dashes.filter';
import dashesWithSpaces from './dashes_with_spaces.filter';
import titleCase from './title_case.filter';
import deslug from './deslug.filter';

import priceFilterModule from './price.filter';

const dependencies = [
  priceFilterModule
];

export default angular
  .module('filters', dependencies)
  .filter('bookingDate', bookingDate)
  .filter('cityPhoto', cityPhoto)
  .filter('duration', duration)
  .filter('language', language)
  .filter('location', location)
  .filter('meetingTime', meetingTime)
  .filter('nl2br', nl2br)
  .filter('numberOfPeople', numberOfPeople)
  .filter('phone', phone)
  .filter('possessive', possessive)
  .filter('responseTime', responseTime)
  .filter('toDate', toDate)
  .filter('firstName', firstName)
  .filter('booking', booking)
  .filter('longShortDate', longShortDate)
  .filter('guidePrice', priceFilter)
  .filter('limitWords', limitWords)
  .filter('country', country)
  .filter('guideSlug', guideSlug)
  .filter('round', roundFilter)
  .filter('spacesWithDashes', spacesWithDashes)
  .filter('dashesWithSpaces', dashesWithSpaces)
  .filter('titleCase', titleCase)
  .filter('deslug', deslug)
  .name;



// WEBPACK FOOTER //
// ./app/src/filters/index.js